import { Ref } from "react";
import { Mask, Toast } from "antd-mobile";
import { debounce, getSearchParam, filterEmptyValues } from "@/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchWeatherInfoByKeyId, homeStateSelector } from "@store/redux/modules/home";
import { useCallbackState } from "@/utils/hook";
import { fetchLocationData } from "@store/redux/modules/location";
import { getCurrLocation } from "@/utils/location";
import { Dispatch, UnknownAction } from "@reduxjs/toolkit";
import { fetchDataMap } from "../Navigation";
import { homeRoute } from "@/router";
import { useTranslation } from "react-i18next";
export function executeOnce(fn: Function) {
  let executed = false;
  return function (..._args: any) {
    if (!executed) {
      executed = true;
      // @ts-ignore
      fn.apply(this, arguments);
    }
  };
}

export const handleSlideDistance = ({ end = 0, speed = 0.015 }: any = {}) => {
  const { isArLan } = useLanguage();
  const direction = isArLan ? 1 : -1;
  return executeOnce((element: any) => {
    if (!element || end >= 0) return;
    // speed: 速度 默认 0.015px/ms
    const target = Math.abs(end);
    if (target <= 4) return;
    let startTime = Date.now();
    // target / time = 大
    let distance = 0;
    function animate() {
      const endTime = Date.now();
      const diffTime = endTime - startTime;
      if (distance <= target) {
        distance = distance + speed * diffTime;
      } else {
        distance = 0;
      }
      element.style.transform = `translateX(${distance * direction}px)`;
      // console.log("🚀 ~ distancce target:", distance, target, diffTime * speed)
      startTime = Date.now();
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  });
};
function fetchDataByGGApi(position: any, dispatch: any) {
  try {
    let attempt = 0;
    const fetchKeyIdParamByGeo = async () => {
      const condition =
        (isEmptyType(getSearchParam("latitude")) &&
          isEmptyType(getSearchParam("longitude")) &&
          !isEmptyType(getSearchParam("keyId"))) ||
        ((isEmptyType(position) ||
          (!isEmptyType(position?.latitude) &&
            position.latitude * 1 === 0 &&
            !isEmptyType(position?.longitude) &&
            position.longitude * 1 === 0)) &&
          !isEmptyType(getSearchParam("latitude")) &&
          !isEmptyType(getSearchParam("longitude")) &&
          !isEmptyType(getSearchParam("keyId")));

      if (condition) {
        fetchWeatherInfoByKeyId(dispatch, {
          keyId: getSearchParam("keyId"),
          test: isDevEnv ? 1 : undefined,
        });
        return;
      }
      const params = filterEmptyValues({
        test: isDevEnv ? 1 : undefined,
        type:
          position.latitude === 0 &&
          position.longitude === 0 &&
          isEmptyType(getSearchParam("latitude")) &&
          isEmptyType(getSearchParam("longitude"))
            ? "server"
            : "geo",
        search: position.latitude + "," + position.longitude,
        latitude: getSearchParam("latitude"),
        longitude: getSearchParam("longitude"),
        clientIp: getSearchParam("clientIp"),
      });
      const resData: any = await fetchLocationData(params).catch(_err => {
        // 报错后再执行一次
        if (attempt < 2 && position.latitude != 0 && position.longitude != 0) {
          position = { latitude: 0, longitude: 0 };
          attempt++;
          fetchKeyIdParamByGeo();
        }
      });
      fetchWeatherInfoByKeyId(dispatch, {
        keyId: resData?.info?.key,
        test: isDevEnv ? 1 : undefined,
      });
    };
    fetchKeyIdParamByGeo();
  } catch (err: any) {
    Toast.show({
      icon: "fail",
      content: err.message,
    });
  }
}

export async function refreshUserLocation(dispatch: Dispatch<UnknownAction>) {
  const localSelectCity = LocalStorage.getItem("select_city");
  if (!isEmptyType(localSelectCity)) {
    fetchWeatherInfoByKeyId(dispatch, {
      keyId: localSelectCity.Key,
      test: isDevEnv ? 1 : undefined,
    });
    return;
  }
  let position: any = { latitude: 0, longitude: 0 };
  try {
    position = await getCurrLocation();
    // @ts-ignore
    window.globalState = {
      // @ts-ignore
      ...window.globalState,
      position,
    };
    fetchDataByGGApi(position, dispatch);
  } catch (err) {
    // @ts-ignore
    window.globalState = {
      // @ts-ignore
      ...window.globalState,
      position,
    };
    fetchDataByGGApi(position, dispatch);
  }
}
function LocationMask(_props: any, ref: Ref<unknown> | undefined) {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useCallbackState("");
  const [locationList, setLocationList] = useCallbackState([]);
  const [visible, setVisible] = useState(false);
  let { info = {} } = useSelector(homeStateSelector);
  const { pathname } = useLocation();
  const searchInput = useRef<any>(null);
  if (isEmptyType(info)) {
    info = LocalStorage.getItem("info");
  }
  function handleClick() {
    if (!inputValue) return;
    searchInput.current.value = "";
    setLocationList([]);
    setInputValue("");
  }
  function handleChange({ target: { value } }: any) {
    setInputValue(value, async (cityName: any) => {
      if (!cityName.trim()) return setLocationList([]);
      const res: any = await fetchLocationData({
        test: isDevEnv ? 1 : undefined,
        type: "city",
        search: cityName,
      });
      setLocationList(res?.info?.list ?? []);
    });
  }
  async function fetchTimeZone(item: any) {
    try {
      const params = {
        keyId: item.Key,
      };
      const resData: any = await timeZoneApi.query(params);
      LocalStorage.setItem("time_zone", resData.data.timeZone);
      refreshApi(item);
    } catch (error) {
      refreshApi(item);
    }
  }
  function refreshApi(item: any) {
    switch (pathname) {
      case homeRoute.path:
        fetchWeatherInfoByKeyId(dispatch, {
          keyId: item.Key,
          test: isDevEnv ? 1 : undefined,
        });
        break;
      default:
        fetchDataMap[pathname](item.Key);
        break;
    }
  }

  function handleSelectCity(item: { Key: any }) {
    return () => {
      searchInput.current.value = "";
      setLocationList([]);
      setVisible(false);
      LocalStorage.setItem("select_city", item);
      // refreshApi(item);
      fetchTimeZone(item);
    };
  }

  useImperativeHandle(ref, () => ({
    setVisible,
    visible,
  }));
  const animateNode = useRef<any>(null);
  requestAnimationFrame(() => {
    handleSlideDistance({
      end: animateNode?.current?.parentElement?.clientWidth - animateNode?.current?.clientWidth,
    })(animateNode.current);
  });
  const maskStyle = {
    top: "50px",
    height: `calc(100vh - 50px)`,
    backdropFilter: "blur(3px)",
  };
  const iconFontStyle = {
    color: "#999",
    fontSize: "16px",
    lineHeight: "30px",
  };
  const { t: $t } = useTranslation();
  const { lan } = useLanguage();
  return (
    <>
      <Mask
        style={maskStyle}
        color="rgba(0, 0, 0, 0.3)"
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
      >
        <div className="w-full p-15 rounded-tl-0 rounded-[0_0_10_10] bg-[#fff] absolute top-0 left-0 z-1 color-[#333]">
          <div className="relative w-full h-30 lh-30 inline-block">
            <IconFont
              iconName={inputValue ? "icon-guanbi" : "icon-sousuoxiao"}
              onClick={handleClick}
              style={iconFontStyle}
              className="w-30 h-30 absolute top-0 right-0 z-1 text-center color-#999"
            />
            <input
              ref={searchInput}
              className="w-full h-30 bg-[#eee] rounded-30 border-none p-[0_10] relative font-size-16"
              type="search"
              placeholder={$t("title20")}
              onFocus={({ target }) => {
                console.log(target);
                target.placeholder = "";
              }}
              onBlur={({ target }) => {
                target.placeholder = $t("title20");
              }}
              onChange={debounce(handleChange, 800)}
            />
          </div>
          <div className="p-[15_0_5_0] overflow-hidden whitespace-nowrap text-ellipsis flex items-center gap-x-5">
            {renderIconFont("icon-weizhi1", {
              color: "#333",
              fontSize: "16px",
            })}
            <span
              onClick={() => {
                searchInput.current.value = "";
                setLocationList([]);
                LocalStorage.removeItem("select_city");
                LocalStorage.removeItem("time_zone");
                setVisible(false);
                refreshUserLocation(dispatch);
              }}
            >
              {$t("title19")}
            </span>
          </div>
          <ul className="w-full max-h-280 overflow-y-scroll p-[5_10]">
            {locationList.map((item: any, index: number) => (
              <li
                className="h-30 lh-30 w-full overflow-hidden  whitespace-nowrap text-ellipsis"
                key={index}
                onClick={handleSelectCity(item)}
              >
                {item.LocalizedName}, {item.AdministrativeArea.LocalizedName}, {item.Country.LocalizedName}
              </li>
            ))}
          </ul>
        </div>
      </Mask>
      <AnimateSlide $duration={8} ref={animateNode} $unit="px" $playState="paused">
        {/* 如果你只需要在某个组件中获取这些参数，可以。 */}
        {info?.name}
        {/* 巴西葡萄牙语特殊处理 */}
        {info?.name && info?.area?.LocalizedName ? (lan?.toLocaleLowerCase?.() === "pt" ? ", " : ",") : ""}
        {info?.area?.LocalizedName}
      </AnimateSlide>
    </>
  );
}

export default forwardRef(LocationMask);
